import React from 'react';
import SelectIntervalsPerDay from '../../../../../../controllers/SelectIntervalsPerDay';
import IgnoreIntervalsPerDay from '../../../../../../controllers/IgnoreIntervalsPerDay';
import { useFormWatch } from '../../../../../../../../helpers/formManager';
import { fieldPathBuilders } from '../../../../../../shared/configs/acceptanceForm';
import { useDayIsImmutable } from '../../../../hooks/isImmutableFns';
import styles from './index.module.scss';

const IntervalsPerDayBlock = ({ deskIndex, entityKey }) => {
  const disabled = useDayIsImmutable(deskIndex, entityKey);

  return (
    <div className={styles.root}>
      <IntervalsPerDayWrapper
        deskIndex={deskIndex}
        entityKey={entityKey}
        disabled={disabled}
      />
      <IgnoreIntervalsPerDay
        deskIndex={deskIndex}
        entityKey={entityKey}
        className={styles.ignoreDailySlots}
        disabled={disabled}
      />
    </div>
  );
};

export default IntervalsPerDayBlock;

const { intervals: createIntervalsName } =
  fieldPathBuilders.deskScheduleSetting;

function IntervalsPerDayWrapper({ deskIndex, entityKey, disabled }) {
  // const intervals = useFormWatch({
  //   name: createIntervalsName(deskIndex, entityKey),
  // });

  // const activeIntervals = intervals?.filter(({ active }) => active);

  return (
    <SelectIntervalsPerDay
      deskIndex={deskIndex}
      entityKey={entityKey}
      // intervalCount={activeIntervals?.length}
      disabled={disabled}
    />
  );
}
